import { useEffect } from 'react';

// The first screen the app shows must not take focus, so the skip link stays the first Tab stop.
let firstScreenShown = false;
// Tests flip it to model "first load" (false) versus "a later screen change" (true).
export const setFirstScreenShown = (shown) => {
  firstScreenShown = shown;
};

// Targets that outrank the heading: SessionExpired's heading, any open dialog (ToS), T9's Refresh.
const otherTargetOwnsFocus = () =>
  document.querySelector('[data-focus-owner], [role="dialog"]') !== null ||
  document.activeElement?.id === 'refresh-appointments-btn';

// Move focus to the screen's h1 when it mounts after the first screen, because the
// clicked control unmounts on every screen change (WCAG 2.4.3). Mount-only, so a
// title edit on the same screen never steals focus from a control.
export default function useFocusHeadingOnScreenChange(headingRef) {
  useEffect(() => {
    const heading = headingRef.current;
    if (!firstScreenShown) {
      firstScreenShown = true;
    } else {
      if (!otherTargetOwnsFocus()) heading?.focus();
    }
  }, [headingRef]);
}
